    //@ts-nocheck
    import { RumInit } from '@maersk-global/telemetry-web-sdk/dist/index.cjs.js';
    import { AuthService, AuthorizationRoles } from './src/services/auth-service';
    import { AuthorizationRoles } from './src/services/auth-service';
   const rumConfiguration = (<any>window)["appenv"].rumConfig

    export const faro = RumInit({
    app: {
        name:rumConfiguration?.appName,
        version: '2.2.0',
        environment: rumConfiguration?.environment,
    },
    apiKey: rumConfiguration?.apiKey,
    debug: false,
    traceLog: false,
    useSendBeacon: true,
    performanceInstrument: {
        ignoreEvents: ['msal.*'], // To ignore certain events pass a list of exact events names or regex
    },
    });

    export const setUserEvent = (
        email: string,
        username: string,
        userRoleType: boolean
    ) => {
        faro.api.setUser({
            id: email,
            username: username,
            attributes: {
                role: AuthService.userHasRole(AuthorizationRoles.MaerskInternal) ? "MaerskInternalUser":"MaerskExternalUser",
            }
        });
        setUsersTypeEvent(username, userRoleType);
    };

    export const setUsersTypeEvent = (username: string, userRoleType: boolean) => {
        faro.api.pushEvent('Login', {
            username: username,
            attributes: {
                role: AuthService.userHasRole(AuthorizationRoles.MaerskInternal) ? "MaerskInternalUser":"MaerskExternalUser",
            }
    });
    if (userRoleType) {
        faro.api.pushEvent('InternalUsers', {
        date: new Date().toISOString(),
        count: '1',
        username: username,
        });
    } else {
        faro.api.pushEvent('ExternalUsers', {
        isUserInternal: userRoleType.toString(),
        isUserExternal: (!userRoleType).toString(),
        });
    }
    };